export const ACTION_TYPES = {
  SET_STEPS_ACTIONS: 'step/SET_STEPS_ACTIONS',
  SET_ACTION_BEFORE_PREVIOUS_STEP: 'step/SET_ACTION_BEFORE_PREVIOUS_STEP',
  SET_ACTION_BEFORE_NEXT_STEP: 'step/SET_ACTION_BEFORE_NEXT_STEP',
  TOGGLE_PREVIOUS_BUTTON: 'step/TOGGLE_PREVIOUS_BUTTON',
  SET_PREVIOUS_BUTTON_LABEL: 'step/SET_PREVIOUS_BUTTON_LABEL',
  TOGGLE_NEXT_BUTTON: 'step/TOGGLE_NEXT_BUTTON',
  SET_NEXT_BUTTON_LABEL: 'step/SET_NEXT_BUTTON_LABEL',
  SET_PREVIOUS_NEXT_BUTTON_LABEL: 'step/SET_PREVIOUS_NEXT_BUTTON_LABEL',
  TOGGLE_PREVIOUS_NEXT_BUTTON: 'step/TOGGLE_PREVIOUS_NEXT_BUTTON',
  DISABLE_BUTTONS: 'step/DISABLE_BUTTONS',
  DISABLE_PREVIOUS_BUTTON: 'step/DISABLE_PREVIOUS_BUTTON',
  DISABLE_NEXT_BUTTON: 'step/DISABLE_NEXT_BUTTON',
  HIDE_BUTTONS: 'step/HIDE_BUTTONS',
  SET_FORM: 'step/SET_FORM',
  SET_FULL_SIZE: 'step/SET_FULL_SIZE',
  UPDATE_STEP: 'step/UPDATE_STEP',
  SET_JOURNEY_STEPS: 'step/SET_JOURNEY_STEPS',
  SET_STEP_MESSAGE: 'step/SET_STEP_MESSAGE',
  SET_STEP_TITLE: 'step/SET_STEP_TITLE',
  SET_STEP_SUB_TITLE: 'step/SET_STEP_SUB_TITLE',
  SET_ERROR: 'step/SET_ERROR',
  RESET_ERROR: 'step/RESET_ERROR',
  SET_STEPS_LOADED: 'step/SET_STEPS_LOADED'
};

export const setStepMessage = ({ title, subTitles }) => {
  return {
    type: ACTION_TYPES.SET_STEP_MESSAGE,
    payload: {
      title,
      subTitles
    }
  };
};
